module.exports = __webpack_public_path__ + "static/media/Help-Loved-Ones-Believe-White1b.3c81c325.jpg";